// extracted by mini-css-extract-plugin
export var label = "_jh-2";
export var slideContainer = "_jh-0";
export var slider = "_jh-1";